const {
	UMAMI_CLIENT_TIMEOUT_MS,
	UMAMI_CLIENT_USER_AGENT,
	UMAMI_CLIENT_TIME_PERIOD,
	UMAMI_CLIENT_TIME_UNIT,
	UMAMI_CLIENT_TIMEZONE,
	UMAMI_CLIENT_METRIC_TYPE,
} = process.env;

export const DEFAULT_HTTP_CLIENT_TIMEOUT_MS = UMAMI_CLIENT_TIMEOUT_MS
	? parseInt(UMAMI_CLIENT_TIMEOUT_MS)
	: 2000;
export const DEFAULT_USER_AGENT =
	UMAMI_CLIENT_USER_AGENT ??
	"Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:102.0) Gecko/20100101 Firefox/102.0";
export const DEFAULT_TIME_PERIOD = UMAMI_CLIENT_TIME_PERIOD ?? "24h";
export const DEFAULT_TIME_UNIT = UMAMI_CLIENT_TIME_UNIT ?? "hour";
export const DEFAULT_TIMEZONE = UMAMI_CLIENT_TIMEZONE ?? "America/Toronto";
export const DEFAULT_METRIC_TYPE = UMAMI_CLIENT_METRIC_TYPE ?? "url";
